// Labels for the ContentTypeDto enum values returned by GET /api/v2/ContentSearch (countsByType/items).
export const CONTENT_TYPE_LABELS = {
  Dramaturgy: "Dramaturgia",
  Variety: "Variedades",
  Research: "Pesquisa",
  LiteraryWork: "Obra Literária",
};

export const getContentTypeLabel = (type) => CONTENT_TYPE_LABELS[type];

// Types searched when associating a content to another one (research is searched separately).
export const ASSOCIABLE_PROJECT_TYPES = ["Dramaturgy", "Variety", "LiteraryWork"];
export const ASSOCIABLE_RESEARCH_TYPES = ["Research"];

const LABEL_TO_CONTENT_TYPE = Object.entries(CONTENT_TYPE_LABELS).reduce(
  (map, [type, label]) => ({ ...map, [label]: type }),
  {}
);

// Reverse lookup used to translate the PT-BR type labels already used across the search UI
// (SearchNavigation tabs, ParameterizedSearchModal's typeOptions) into the ContentTypeDto enum.
export const getContentTypeByLabel = (label) => LABEL_TO_CONTENT_TYPE[label];
